import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Divider,
  CircularProgress,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  content1,
  isPending = false,
  okText = 'Confirm',
  noText = 'Cancel',
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" sx={{ maxWidth: '600px', margin: 'auto' }}>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography>{content}</Typography>
        <Typography mt={1}>{content1}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="default" onClick={onClose} disabled={isPending}>
          {noText}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={isPending}
          startIcon={isPending ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isPending ? 'Processing...' : okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
